export function initSampleSeriesWeboothSearch() {
    initBaseCategorySet();
    initVenueSet();
    initThumbnailHover();
}
// カテゴリーが指定されていた場合、formのカテゴリーを書き換えしサブミット
function initBaseCategorySet() {
    const baseCategories = document.getElementsByClassName("select-base-category");
    const inputbaseCategory = document.querySelector("#base-category-id");
    //formオブジェクトを取得する
    const fm = document.querySelector("#webooth-search");
    if (baseCategories === null)
        return;
    for (let i = 0; i < baseCategories.length; i++) {
        baseCategories[i].addEventListener("click", function () {
            inputbaseCategory.value = baseCategories[i].getAttribute("data-value");
            //Submit実行
            fm.submit();
        });
    }
}
// 開催地が押された場合、formの開催地を書き換えしサブミット
function initVenueSet() {
    const activeVenues = document.getElementsByClassName("active-venue");
    const inactiveVenues = document.getElementsByClassName("inactive-venue");
    //formオブジェクトを取得する
    const fm = document.querySelector("#webooth-search");
    if (activeVenues === null)
        return;
    for (let i = 0; i < activeVenues.length; i++) {
        activeVenues[i].addEventListener("click", function () {
            window.console.log("Click");
            window.console.log(activeVenues[i].getAttribute("data-value"));
            const inputActiveVenues = document.querySelector("#venue-status-" + activeVenues[i].getAttribute("data-value"));
            inputActiveVenues.value = "0";
            //Submit実行
            fm.submit();
        });
    }
    if (inactiveVenues === null)
        return;
    for (let i = 0; i < inactiveVenues.length; i++) {
        inactiveVenues[i].addEventListener("click", function () {
            window.console.log("Click");
            window.console.log(inactiveVenues[i].getAttribute("data-value"));
            const inputInactiveVenues = document.querySelector("#venue-status-" + inactiveVenues[i].getAttribute("data-value"));
            inputInactiveVenues.value = "1";
            //Submit実行
            fm.submit();
        });
    }
}
// サムネイル画像にマウスオンした時に動画のサムネイル画像を表示する
function initThumbnailHover() {
    const thumbnails = document.querySelectorAll(".thumbnail");
    if (thumbnails === null)
        return;
    for (const thumbnail of thumbnails) {
        thumbnail.addEventListener("mouseover", () => {
            const imageIndex = thumbnail.dataset.weboothproductimageindex;
            if (imageIndex === null)
                return;
            const productImage = document.querySelector("#webooth-product-image-" + imageIndex);
            if (productImage === null)
                return;
            const thumbnailImage = document.querySelector("#webooth-thumbnail-image-" + imageIndex);
            if (thumbnailImage === null)
                return;
            productImage.style.display = 'none';
            thumbnailImage.style.display = '';
        });
        thumbnail.addEventListener("mouseout", () => {
            const imageIndex = thumbnail.dataset.weboothproductimageindex;
            if (imageIndex === null)
                return;
            const productImage = document.querySelector("#webooth-product-image-" + imageIndex);
            if (productImage === null)
                return;
            const thumbnailImage = document.querySelector("#webooth-thumbnail-image-" + imageIndex);
            if (thumbnailImage === null)
                return;
            productImage.style.display = '';
            thumbnailImage.style.display = 'none';
        });
    }
}
